//Include Both Helper File with needed methods
import { base64toBlob } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import formatDataService from "services/FormatDataService";
import {
  createRegistryDelegateFail,
  createRegistryDelegateSuccess,
  createRegistryInvoicesFail,
  createRegistryInvoicesSuccess,
  createRequestInvoiceCodeFail,
  createRequestInvoiceCodeSuccess,
  downloadXmlRegistryDelegateFail,
  downloadXmlRegistryDelegateSuccess,
  downloadXmlRegistryInvoicesFail,
  downloadXmlRegistryInvoicesSuccess,
  downloadXmlRequestInvoiceCodeFail,
  downloadXmlRequestInvoiceCodeSuccess,
  editRegistryDelegateFail,
  editRegistryDelegateSuccess,
  editRegistryInvoicesFail,
  editRegistryInvoicesSuccess,
  editRequestInvoiceCodeFail,
  editRequestInvoiceCodeSuccess,
  getDetailRegistryDelegateFail,
  getDetailRegistryDelegateSuccess,
  getDetailRegistryInvoicesFail,
  getDetailRegistryInvoicesSuccess,
  getDetailRequestInvoiceCodeFail,
  getDetailRequestInvoiceCodeSuccess,
  getListRegistryDelegateFail,
  getListRegistryDelegateSuccess,
  getListRegistryInvoicesFail,
  getListRegistryInvoicesSuccess,
  getListRequestInvoiceCodeFail,
  getListRequestInvoiceCodeSuccess,
  previewPdfFail,
  previewPdfSuccess,
  releaseRegistryDelegateFail,
  releaseRegistryDelegateSuccess,
  releaseRegistryInvoicesFail,
  releaseRegistryInvoicesSuccess,
  releaseRequestInvoiceCodeFail,
  releaseRequestInvoiceCodeSuccess,
  transferUsbFail,
  transferUsbSuccess,
} from "store/actions";
import {
  checkInvoicesCurrentFail,
  checkInvoicesCurrentSuccess,
  downloadPDFInvoicesFail,
  downloadPDFInvoicesSuccess,
  getHistoryTransferFail,
  getHistoryTransferSuccess,
  getReasonDenyReleaseFail,
  getReasonDenyReleaseSuccess,
  previewPdfRegisterInvoiceFail,
  previewPdfRegisterInvoiceSuccess,
} from "./actions";
// Crypto Redux States
import {
  CHECK_INVOICES_CURRENT,
  CREATE_REGISTRY_DELEGATE,
  CREATE_REGISTRY_INVOICES,
  CREATE_REQUEST_INVOICE_CODE,
  DOWNLOAD_PDF_REGISTRY_INVOICES,
  DOWNLOAD_XML_REGISTRY_DELEGATE,
  DOWNLOAD_XML_REGISTRY_INVOICES,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  EDIT_REGISTRY_DELEGATE,
  EDIT_REGISTRY_INVOICES,
  EDIT_REQUEST_INVOICE_CODE,
  GET_DETAIL_REGISTRY_DELEGATE,
  GET_DETAIL_REGISTRY_INVOICES,
  GET_DETAIL_REQUEST_INVOICE_CODE,
  GET_HISTORY_TRANSFER,
  GET_LIST_REGISTRY_DELEGATE,
  GET_LIST_REGISTRY_INVOICES,
  GET_LIST_REQUEST_INVOICE_CODE,
  GET_REASON_DENY_RELEASE,
  PREVIEW_PDF,
  PREVIEW_PDF_REGISTER_INVOICE,
  RELEASE_REGISTRY_DELEGATE,
  RELEASE_REGISTRY_INVOICES,
  RELEASE_REQUEST_INVOICE_CODE,
  TRANSFER_USB,
} from "./actionTypes";
function* fetchPreviewPdfRegisterInvoice({ id, typePreview }) {
  try {
    // Call api
    const response = yield call(formatDataService.reviewPdfRegisterInvoice, id);
    if (response.result && response.file) {
      const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(blob);
      yield put(
        previewPdfRegisterInvoiceSuccess({ url: url, typePreview: typePreview })
      );
    } else {
      yield put(previewPdfRegisterInvoiceFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfRegisterInvoiceFail(error));
  }
}
function* fetchGetRegistryInvoices({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { buStoreHeader } = yield select(state => state.Dashboard);
    // Call api
    const response = yield call(
      formatDataService.listRegistryInvoices,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      buStoreHeader
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListRegistryInvoicesSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRegistryInvoicesFail(error));
  }
}

function* fetchGetRegistryDelegate({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      formatDataService.listRegistryDelegate,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListRegistryDelegateSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRegistryDelegateFail(error));
  }
}

function* fetchGetRequestInvoiceCodes({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      formatDataService.listRequestInvoiceCodes,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListRequestInvoiceCodeSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRequestInvoiceCodeFail(error));
  }
}

function* fetchGetDetailRegistryInvoices({ id }) {
  try {
    const response = yield call(formatDataService.detailRegistryInvoices, id);
    // console.log("response", response);
    yield put(getDetailRegistryInvoicesSuccess(response));
  } catch (error) {
    yield put(getDetailRegistryInvoicesFail(error));
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

function* fetchCreateRegistryInvoices({ data }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      formatDataService.createRegistryInvoices,
      data,
      buStoreHeader
    );
    // Wait XML generate
    yield sleep(1);
    yield put(createRegistryInvoicesSuccess(response));
  } catch (error) {
    yield put(createRegistryInvoicesFail(error));
  }
}

function* fetchEditRegistryInvoices({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editRegistryInvoices,
      data,
      id
    );
    // Wait XML generate
    yield sleep(1);
    yield put(editRegistryInvoicesSuccess(response));
  } catch (error) {
    yield put(editRegistryInvoicesFail(error));
  }
}

function* fetchGetDetailRegistryDelegate({ id }) {
  try {
    const response = yield call(formatDataService.detailRegistryDelegate, id);
    // console.log("response", response);
    yield put(getDetailRegistryDelegateSuccess(response));
  } catch (error) {
    yield put(getDetailRegistryDelegateFail(error));
  }
}

function* fetchCreateRegistryDelegate({ data }) {
  try {
    const response = yield call(formatDataService.createRegistryDelegate, data);
    // Wait XML generate
    yield sleep(1);
    yield put(createRegistryDelegateSuccess(response));
  } catch (error) {
    yield put(createRegistryDelegateFail(error));
  }
}

function* fetchEditRegistryDelegate({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editRegistryDelegate,
      data,
      id
    );
    // Wait XML generate
    yield sleep(1);
    yield put(editRegistryDelegateSuccess(response));
  } catch (error) {
    yield put(editRegistryDelegateFail(error));
  }
}

function* fetchGetDetailRequestInvoiceCode({ id }) {
  try {
    const response = yield call(formatDataService.detailRequestInvoiceCode, id);
    yield put(getDetailRequestInvoiceCodeSuccess(response));
  } catch (error) {
    yield put(getDetailRequestInvoiceCodeFail(error));
  }
}

function* fetchCreateRequestInvoiceCode({ data }) {
  try {
    const response = yield call(
      formatDataService.createRequestInvoiceCode,
      data
    );
    // Wait XML generate
    yield sleep(1);
    yield put(createRequestInvoiceCodeSuccess(response));
  } catch (error) {
    yield put(createRequestInvoiceCodeFail(error));
  }
}

function* fetchEditRequestInvoiceCode({ data, id }) {
  try {
    const response = yield call(
      formatDataService.editRequestInvoiceCode,
      data,
      id
    );
    // Wait XML generate
    yield sleep(1);
    yield put(editRequestInvoiceCodeSuccess(response));
  } catch (error) {
    yield put(editRequestInvoiceCodeFail(error));
  }
}

function* fetchDownloadXmlRegistryInvoices({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLRegistryInvoices,
      resource_id,
      responseType
    );
    // console.log("fetchDownloadXmlRegistryInvoices", response);
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);

          yield put(
            downloadXmlRegistryInvoicesSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(downloadXmlRegistryInvoicesFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlRegistryInvoicesSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
      //   yield put(downloadXmlRegistryInvoicesSuccess(response, null, null));
    } else {
      yield put(downloadXmlRegistryInvoicesFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlRegistryInvoicesFail(error));
  }
}
function* fetchDownloadPDFRegistryInvoices({
  resource_id,
  fileDownloadName,
  downloadType,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFilePDFRegistryInvoices,
      { resource_id, downloadType, responseType }
    );
    const responseTypeDown = "blob";
    if (response) {
      if (responseTypeDown === "blob") {
        if (response.file) {
          const blob = base64toBlob(response.file);
          const url = URL.createObjectURL(blob);
          yield put(
            downloadPDFInvoicesSuccess(null, url, fileDownloadName + ".pdf")
          );
        } else {
          yield put(downloadPDFInvoicesFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadPDFInvoicesSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".pdf"
          )
        );
      }
      //   yield put(downloadXmlRegistryInvoicesSuccess(response, null, null));
    } else {
      yield put(downloadPDFInvoicesFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadPDFInvoicesFail(error));
  }
}

function* fetchDownloadXmlRegistryDelegate({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLRegistryDelegates,
      resource_id,
      responseType
    );
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlRegistryDelegateSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(downloadXmlRegistryDelegateFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlRegistryDelegateSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
    } else {
      yield put(downloadXmlRegistryDelegateFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlRegistryDelegateFail(error));
  }
}

function* fetchDownloadXmlRequestInvoiceCode({
  resource_id,
  fileDownloadName,
  responseType = "blob",
}) {
  try {
    const response = yield call(
      formatDataService.downloadFileXMLRequestInvoiceCode,
      resource_id,
      responseType
    );
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlRequestInvoiceCodeSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(
            downloadXmlRequestInvoiceCodeFail("Download file thất bại")
          );
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlRequestInvoiceCodeSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
    } else {
      yield put(downloadXmlRequestInvoiceCodeFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlRequestInvoiceCodeFail(error));
  }
}

function* fetchReleaseRegistryInvoices({ id }) {
  try {
    const response = yield call(formatDataService.releaseRegistryInvoices, id);
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseRegistryInvoicesSuccess());
    } else {
      yield put(releaseRegistryInvoicesFail("Gửi phát hành tờ khai thất bại"));
    }
  } catch (error) {
    yield put(releaseRegistryInvoicesFail("Gửi phát hành tờ khai thất bại"));
  }
}

function* fetchReleaseRegistryDelegates({ id }) {
  try {
    const response = yield call(formatDataService.releaseRegistryDelegates, id);
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseRegistryDelegateSuccess());
    } else {
      yield put(releaseRegistryDelegateFail("Gửi phát hành tờ khai thất bại"));
    }
  } catch (error) {
    yield put(releaseRegistryDelegateFail("Gửi phát hành tờ khai thất bại"));
  }
}

function* fetchReleaseRequestInvoiceCodes({ id }) {
  try {
    const response = yield call(
      formatDataService.releaseRequestInvoiceCodes,
      id
    );
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseRequestInvoiceCodeSuccess());
    } else {
      yield put(releaseRequestInvoiceCodeFail("Phát hành đề nghị thất bại"));
    }
  } catch (error) {
    yield put(releaseRequestInvoiceCodeFail("Phát hành đề nghị thất bại"));
  }
}

function* fetchPreviewPdf({ resourceId }) {
  try {
    // Call api
    const response = yield call(formatDataService.previewPDF, resourceId);
    if (response) {
      const fileURL = URL.createObjectURL(response);
      yield put(previewPdfSuccess(fileURL));
      // yield put(previewPdfSuccess("PDF"));
    } else {
      yield put(previewPdfFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfFail(error));
  }
}

function* fetchTransferUsb({
  id,
  typeSend, // TYPE_REGISTER = 1, TYPE_INVOICE = 2
  content,
}) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(formatDataService.transfer, data);
    if (response.result) {
      yield put(transferUsbSuccess());
    } else {
      yield put(transferUsbFail(response?.error?.content));
    }
  } catch (error) {
    yield put(transferUsbFail("Gửi phát hành tờ khai thất bại"));
  }
}

function* fetchGetReasonDenyRelease({ id, path }) {
  try {
    const response = yield call(formatDataService.errorRelease, id, path);
    if (response.result) {
      yield put(
        getReasonDenyReleaseSuccess(
          response.items.map(item => {
            return {
              code: item.code,
              description: item.description,
            };
          })
        )
      );
    } else {
      yield put(getReasonDenyReleaseFail("ReasonDenyReleaseFail"));
    }
  } catch (error) {
    yield put(getReasonDenyReleaseFail("ReasonDenyReleaseFail"));
  }
}

function* fetchGetHistoryTransfer({ id, path }) {
  try {
    const response = yield call(formatDataService.historyTransfer, id, path);
    if (response.items) {
      yield put(getHistoryTransferSuccess(response.items));
    } else {
      yield put(getHistoryTransferFail("GetHistoryTransfer Fail"));
    }
  } catch (error) {
    yield put(getHistoryTransferFail("GetHistoryTransfer Fail"));
  }
}
function* checkInvoicesCurrent() {
  try {
    const response = yield call(formatDataService.checkInvoicesCurrent);
    if (response) {
      yield put(checkInvoicesCurrentSuccess(response));
    } else {
      yield put(checkInvoicesCurrentFail("CheckInvoicesCurrent Fail"));
    }
  } catch (error) {
    yield put(checkInvoicesCurrentFail("CheckInvoicesCurrent Fail"));
  }
}

function* dataFormatSaga() {
  yield takeEvery(CHECK_INVOICES_CURRENT, checkInvoicesCurrent);
  yield takeEvery(GET_LIST_REGISTRY_INVOICES, fetchGetRegistryInvoices);
  yield takeEvery(GET_LIST_REGISTRY_DELEGATE, fetchGetRegistryDelegate);
  yield takeEvery(GET_LIST_REQUEST_INVOICE_CODE, fetchGetRequestInvoiceCodes);

  yield takeEvery(GET_DETAIL_REGISTRY_INVOICES, fetchGetDetailRegistryInvoices);
  yield takeEvery(CREATE_REGISTRY_INVOICES, fetchCreateRegistryInvoices);
  yield takeEvery(EDIT_REGISTRY_INVOICES, fetchEditRegistryInvoices);

  yield takeEvery(GET_DETAIL_REGISTRY_DELEGATE, fetchGetDetailRegistryDelegate);
  yield takeEvery(CREATE_REGISTRY_DELEGATE, fetchCreateRegistryDelegate);
  yield takeEvery(EDIT_REGISTRY_DELEGATE, fetchEditRegistryDelegate);

  yield takeEvery(
    GET_DETAIL_REQUEST_INVOICE_CODE,
    fetchGetDetailRequestInvoiceCode
  );
  yield takeEvery(CREATE_REQUEST_INVOICE_CODE, fetchCreateRequestInvoiceCode);
  yield takeEvery(EDIT_REQUEST_INVOICE_CODE, fetchEditRequestInvoiceCode);

  yield takeEvery(
    DOWNLOAD_XML_REGISTRY_INVOICES,
    fetchDownloadXmlRegistryInvoices
  );
  yield takeEvery(
    DOWNLOAD_PDF_REGISTRY_INVOICES,
    fetchDownloadPDFRegistryInvoices
  );

  yield takeEvery(
    DOWNLOAD_XML_REGISTRY_DELEGATE,
    fetchDownloadXmlRegistryDelegate
  );
  yield takeEvery(
    DOWNLOAD_XML_REQUEST_INVOICE_CODE,
    fetchDownloadXmlRequestInvoiceCode
  );
  yield takeEvery(PREVIEW_PDF_REGISTER_INVOICE, fetchPreviewPdfRegisterInvoice);
  yield takeEvery(RELEASE_REGISTRY_INVOICES, fetchReleaseRegistryInvoices);
  yield takeEvery(RELEASE_REGISTRY_DELEGATE, fetchReleaseRegistryDelegates);
  yield takeEvery(PREVIEW_PDF, fetchPreviewPdf);
  yield takeEvery(
    RELEASE_REQUEST_INVOICE_CODE,
    fetchReleaseRequestInvoiceCodes
  );
  yield takeEvery(TRANSFER_USB, fetchTransferUsb);
  yield takeEvery(GET_REASON_DENY_RELEASE, fetchGetReasonDenyRelease);
  yield takeEvery(GET_HISTORY_TRANSFER, fetchGetHistoryTransfer);
}

export default dataFormatSaga;
